<div 
    *ngFor="let alert of alerts" 
    class="{{cssClass(alert)}} alert-dismissable alert-slide">
    {{alert.message}}
    <i class="fa fa-times close" (click)="removeAlert(alert)"></i>    
</div>